import { Grid, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export interface Kenmerk {
  label: string;
  waarde: ReactNode;
}

/**
 * Een overzicht van kenmerken met een label en een waarde, in kolommen.
 * @param props De kenmerken en het aantal kolommen op een breed scherm.
 * @returns Het overzicht.
 */
export function Kenmerken({ items, kolommen = 2 }: { items: readonly Kenmerk[]; kolommen?: 1 | 2 | 3 | undefined }) {
  return (
    <Grid container spacing={2}>
      {items.map((kenmerk) => (
        <Grid key={kenmerk.label} size={{ xs: 12, sm: kolommen === 1 ? 12 : 6, md: 12 / kolommen }}>
          <Typography variant="caption" color="text.secondary" component="div">
            {kenmerk.label}
          </Typography>
          <Typography component="div" sx={{ overflowWrap: 'anywhere' }}>
            {kenmerk.waarde === null || kenmerk.waarde === undefined || kenmerk.waarde === '' ? '–' : kenmerk.waarde}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
}
